/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetNutrientConfigQueryResponse, FilesControllerGetNutrientConfigPathParams, FilesControllerGetNutrientConfig400, FilesControllerGetNutrientConfig401, FilesControllerGetNutrientConfig403, FilesControllerGetNutrientConfig404 } from "../../models/filesController/FilesControllerGetNutrientConfig";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerGetNutrientConfig } from "../../clients/filesService/filesControllerGetNutrientConfig";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerGetNutrientConfigQueryKey = (id: FilesControllerGetNutrientConfigPathParams["id"]) => [{
  url: '/api/v1/files/:id/nutrient-config',
  params: {
    id: id
  }
}] as const;
export type FilesControllerGetNutrientConfigQueryKey = ReturnType<typeof filesControllerGetNutrientConfigQueryKey>;
export function filesControllerGetNutrientConfigQueryOptions(id: FilesControllerGetNutrientConfigPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerGetNutrientConfigQueryKey(id);
  return queryOptions<FilesControllerGetNutrientConfigQueryResponse, ResponseErrorConfig<FilesControllerGetNutrientConfig400 | FilesControllerGetNutrientConfig401 | FilesControllerGetNutrientConfig403 | FilesControllerGetNutrientConfig404>, FilesControllerGetNutrientConfigQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerGetNutrientConfig(id, config);
    }
  });
}

/**
 * @description Returns all data required to render a file via Nutrient, including JWT token, prerender status, fileUuid, and serverUrl.
 * @summary Get Nutrient viewer configuration for a file
 * {@link /api/v1/files/:id/nutrient-config}
 */
export function useFilesControllerGetNutrientConfig<TData = FilesControllerGetNutrientConfigQueryResponse, TQueryData = FilesControllerGetNutrientConfigQueryResponse, TQueryKey extends QueryKey = FilesControllerGetNutrientConfigQueryKey>(id: FilesControllerGetNutrientConfigPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<FilesControllerGetNutrientConfigQueryResponse, ResponseErrorConfig<FilesControllerGetNutrientConfig400 | FilesControllerGetNutrientConfig401 | FilesControllerGetNutrientConfig403 | FilesControllerGetNutrientConfig404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerGetNutrientConfigQueryKey(id);
  const query = useQuery({
    ...filesControllerGetNutrientConfigQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FilesControllerGetNutrientConfig400 | FilesControllerGetNutrientConfig401 | FilesControllerGetNutrientConfig403 | FilesControllerGetNutrientConfig404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}